import { render } from "./AIAssistant.vue?vue&type=template&id=a094a268&scoped=true"
import script from "./AIAssistant.vue?vue&type=script&lang=js"
export * from "./AIAssistant.vue?vue&type=script&lang=js"

import "./AIAssistant.vue?vue&type=style&index=0&id=a094a268&scoped=true&lang=css"
import "./AIAssistant.vue?vue&type=style&index=1&id=a094a268&lang=scss"

import exportComponent from "/Users/sandhiyabaskar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a094a268"]])

export default __exports__